import type { PropsWithChildren } from 'react';
import { useFela } from 'react-fela';

import { container } from './MainSection.rules';
import { useIsLegacySplitLayoutRoute } from './useIsLegacySplitLayoutRoute';

export interface MainSectionProps extends PropsWithChildren {}

export const MainSection = ({ children }: MainSectionProps) => {
    const isLegacySplitLayoutRoute = useIsLegacySplitLayoutRoute();

    const { css } = useFela({ isLegacySplitLayoutRoute });

    return <div className={css(container)}>{children}</div>;
};
